import * as Sentry from "@sentry/react";
import getSentryConfig from "./sentryConfig";

if (window.SENTRY_DSN) {
  //Sentry.init(getSentryConfig(Sentry));
} else if (!window.LOCAL_DEV) {
  console.warn("Sentry error logging disabled");
}
export { Sentry };
